import getQueryString from "@store/Framework/Common/Utilities/getQueryString";
import { useLocation } from "@store/Framework/Store/Data/Pages/PageHooks";
import { ParametersOmitFirst } from "@store/Framework/Types/Common";

const useQueryString = <T>(...args: ParametersOmitFirst<typeof getQueryString>) => {
    const location = useLocation();

    return getQueryString<T>(location.search, ...args);
};

export default useQueryString;
